import { render, staticRenderFns } from "./EditIcon.vue?vue&type=template&id=19b0d214&"
import script from "./EditIcon.vue?vue&type=script&lang=js&"
export * from "./EditIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports